const translation = {
  currentPlan: 'Kế hoạch Hiện tại',
  upgradeBtn: {
    plain: 'Nâng cấp Kế hoạch',
    encourage: 'Nâng cấp Ngay',
    encourageShort: 'Nâng cấp',
  },
  viewBilling: 'Quản lý thanh toán và đăng ký',
  buyPermissionDeniedTip: 'Vui lòng liên hệ với quản trị viên doanh nghiệp của bạn để đăng ký',
  plansCommon: {
    title: 'Chọn một kế hoạch phù hợp với bạn',
    yearlyTip: 'Nhận 2 tháng miễn phí khi đăng ký hàng năm!',
    mostPopular: 'Phổ biến nhất',
    planRange: {
      monthly: 'Hàng tháng',
      yearly: 'Hàng năm',
    },
    month: 'tháng',
    year: 'năm',
    save: 'Tiết kiệm ',
    free: 'Miễn phí',
    currentPlan: 'Kế hoạch Hiện tại',
    contractSales: 'Liên hệ bộ phận bán hàng',
    contractOwner: 'Liên hệ quản lý nhóm',
    startForFree: 'Bắt đầu miễn phí',
    getStartedWith: 'Bắt đầu với ',
    contactSales: 'Liên hệ Bán hàng',
    talkToSales: 'Nói chuyện với Bộ phận Bán hàng',
    modelProviders: 'Nhà cung cấp Mô hình',
    teamMembers: 'Thành viên Nhóm',
    buildApps: 'Xây dựng Ứng dụng',
    vectorSpace: 'Không gian Vector',
    vectorSpaceBillingTooltip: 'Mỗi 1MB có thể lưu trữ khoảng 1.2 triệu ký tự dữ liệu vector hóa (ước tính sử dụng OpenAI Embeddings, thay đổi tùy theo các mô hình).',
    vectorSpaceTooltip: 'Không gian Vector là hệ thống bộ nhớ dài hạn cần thiết cho LLMs để hiểu dữ liệu của bạn.',
    documentsUploadQuota: 'Hạn mức Tải lên Tài liệu',
    documentProcessingPriority: 'Ưu tiên Xử lý Tài liệu',
    documentProcessingPriorityTip: 'Để có ưu tiên xử lý tài liệu cao hơn, vui lòng nâng cấp kế hoạch của bạn.',
    documentProcessingPriorityUpgrade: 'Xử lý nhiều dữ liệu với độ chính xác cao và tốc độ nhanh hơn.',
    priority: {
      'standard': 'Tiêu chuẩn',
      'priority': 'Ưu tiên',
      'top-priority': 'Ưu tiên Cao nhất',
    },
    logsHistory: 'Lịch sử Nhật ký',
    customTools: 'Công cụ Tùy chỉnh',
    unavailable: 'Không có sẵn',
    days: 'ngày',
    unlimited: 'Không giới hạn',
    support: 'Hỗ trợ',
    supportItems: {
      communityForums: 'Diễn đàn cộng đồng',
      emailSupport: 'Hỗ trợ qua email',
      priorityEmail: 'Hỗ trợ qua email & chat ưu tiên',
      logoChange: 'Thay đổi Logo',
      SSOAuthentication: 'Xác thực SSO',
      personalizedSupport: 'Hỗ trợ cá nhân hóa',
      dedicatedAPISupport: 'Hỗ trợ API dành riêng',
      customIntegration: 'Tích hợp và hỗ trợ tùy chỉnh',
      ragAPIRequest: 'Yêu cầu API RAG',
      bulkUpload: 'Tải lên tài liệu hàng loạt',
      agentMode: 'Chế độ Đại lý',
      workflow: 'Quy trình làm việc',
      llmLoadingBalancing: 'Cân bằng tải LLM',
      llmLoadingBalancingTooltip: 'Thêm nhiều khóa API vào mô hình, vượt qua giới hạn tốc độ API một cách hiệu quả.',
    },
    comingSoon: 'Sắp ra mắt',
    member: 'Thành viên',
    memberAfter: 'Thành viên',
    messageRequest: {
      title: 'Số Lượng Tin Nhắn',
      tooltip: 'Hạn mức triệu hồi tin nhắn cho các kế hoạch sử dụng mô hình OpenAI (ngoại trừ gpt4). Các tin nhắn vượt quá giới hạn sẽ sử dụng Khóa API OpenAI của bạn.',
      titlePerMonth: '{{count,number}} tin nhắn/tháng',
    },
    annotatedResponse: {
      title: 'Hạn Mức Quota Phản hồi Đã được Ghi chú',
      tooltip: 'Chỉnh sửa và ghi chú thủ công các phản hồi cung cấp khả năng trả lời câu hỏi chất lượng cao có thể tùy chỉnh cho các ứng dụng. (Chỉ áp dụng trong các ứng dụng trò chuyện)',
    },
    ragAPIRequestTooltip: 'Đề cập đến số lượng cuộc gọi API triệu hồi chỉ khả năng xử lý cơ sở kiến thức của Dify.',
    receiptInfo: 'Chỉ chủ nhóm và quản trị viên nhóm có thể đăng ký và xem thông tin thanh toán',
    annotationQuota: 'Hạn ngạch chú thích',
    priceTip: 'mỗi không gian làm việc/',
    documentsTooltip: 'Hạn ngạch số lượng tài liệu được nhập từ Nguồn Dữ liệu Kiến thức.',
    apiRateLimitTooltip: 'Giới hạn tần suất API áp dụng cho tất cả các yêu cầu được thực hiện thông qua API Dify, bao gồm tạo văn bản, cuộc trò chuyện, thực thi quy trình làm việc và xử lý tài liệu.',
    teamMember_one: '{{count,number}} thành viên trong nhóm',
    apiRateLimit: 'Giới hạn tần suất API',
    annualBilling: 'Hóa đơn hàng năm',
    cloud: 'Dịch vụ đám mây',
    documentsRequestQuota: '{{count,number}}/phút Giới Hạn Tỷ Lệ Yêu Cầu Kiến Thức',
    self: 'Tự lưu trữ',
    comparePlanAndFeatures: 'So sánh các kế hoạch & tính năng',
    freeTrialTip: 'dùng thử miễn phí 200 cuộc gọi OpenAI.',
    freeTrialTipPrefix: 'Đăng ký và nhận một',
    unlimitedApiRate: 'Không giới hạn tỷ lệ API',
    teamWorkspace: '{{count,number}} Không gian làm việc của Đội',
    teamMember_other: '{{count,number}} thành viên trong nhóm',
    documents: '{{count,number}} Tài liệu Kiến thức',
    getStarted: 'Bắt đầu',
    apiRateLimitUnit: '{{count,number}}/ngày',
    freeTrialTipSuffix: 'Không cần thẻ tín dụng',
    documentsRequestQuotaTooltip: 'Chỉ định tổng số hành động mà một không gian làm việc có thể thực hiện mỗi phút trong cơ sở tri thức, bao gồm tạo mới tập dữ liệu, xóa, cập nhật, tải tài liệu lên, thay đổi, lưu trữ và truy vấn cơ sở tri thức. Chỉ số này được sử dụng để đánh giá hiệu suất của các yêu cầu cơ sở tri thức. Ví dụ, nếu một người dùng Sandbox thực hiện 10 lần kiểm tra liên tiếp trong một phút, không gian làm việc của họ sẽ bị hạn chế tạm thời không thực hiện các hành động sau trong phút tiếp theo: tạo mới tập dữ liệu, xóa, cập nhật và tải tài liệu lên hoặc thay đổi.',
  },
  plans: {
    sandbox: {
      name: 'Hộp Cát',
      description: 'Thử nghiệm miễn phí 200 lần GPT',
      includesTitle: 'Bao gồm:',
      for: 'Dùng thử miễn phí các tính năng cốt lõi',
    },
    professional: {
      name: 'Chuyên nghiệp',
      description: 'Dành cho cá nhân và các nhóm nhỏ để mở khóa nhiều sức mạnh với giá cả phải chăng.',
      includesTitle: 'Tất cả trong kế hoạch miễn phí, cộng thêm:',
      for: 'Dành cho các nhà phát triển độc lập/nhóm nhỏ',
    },
    team: {
      name: 'Nhóm',
      description: 'Hợp tác mà không giới hạn và tận hưởng hiệu suất hạng nhất.',
      includesTitle: 'Tất cả trong kế hoạch Chuyên nghiệp, cộng thêm:',
      for: 'Dành cho các đội nhóm vừa',
    },
    enterprise: {
      name: 'Doanh nghiệp',
      description: 'Nhận toàn bộ khả năng và hỗ trợ cho các hệ thống quan trọng cho nhiệm vụ quy mô lớn.',
      includesTitle: 'Tất cả trong kế hoạch Nhóm, cộng thêm:',
      features: {
        2: 'Tính năng Doanh nghiệp Độc quyền',
        1: 'Giấy phép kinh doanh',
        8: 'Hỗ trợ kỹ thuật chuyên nghiệp',
        7: 'Cập nhật và Bảo trì bởi Dify Chính thức',
        5: 'Thỏa thuận SLA bởi các đối tác Dify',
        6: 'An ninh nâng cao và kiểm soát',
        3: 'Nhiều không gian làm việc & Quản lý doanh nghiệp',
        0: 'Giải pháp triển khai mở rộng quy mô cấp doanh nghiệp',
        4: 'SSO',
      },
      price: 'Tùy chỉnh',
      for: 'Dành cho các đội lớn',
      priceTip: 'Chỉ thanh toán hàng năm',
      btnText: 'Liên hệ với Bộ phận Bán hàng',
    },
    community: {
      features: {
        2: 'Tuân thủ Giấy phép Mã nguồn Mở Dify',
        0: 'Tất cả các tính năng cốt lõi được phát hành dưới Kho lưu trữ công khai',
        1: 'Không gian làm việc đơn',
      },
      description: 'Dành cho người dùng cá nhân, nhóm nhỏ hoặc các dự án phi thương mại',
      name: 'Cộng đồng',
      btnText: 'Bắt đầu với Cộng đồng',
      price: 'Miễn phí',
      for: 'Dành cho người dùng cá nhân, nhóm nhỏ hoặc các dự án phi thương mại',
      includesTitle: 'Tính năng miễn phí:',
    },
    premium: {
      features: {
        3: 'Hỗ trợ qua Email & Chat Ưu tiên',
        2: 'Tùy chỉnh Logo & Thương hiệu Ứng dụng Web',
        1: 'Không gian làm việc đơn',
        0: 'Độ tin cậy tự quản lý bởi các nhà cung cấp đám mây khác nhau',
      },
      comingSoon: 'Hỗ trợ Microsoft Azure & Google Cloud Sẽ Đến Sớm',
      priceTip: 'Dựa trên Thị trường Đám mây',
      btnText: 'Nhận Premium trong',
      description: 'Dành cho các tổ chức và nhóm vừa',
      price: 'Có thể mở rộng',
      includesTitle: 'Mọi thứ từ Cộng đồng, cộng thêm:',
      for: 'Dành cho các tổ chức và nhóm vừa',
      name: 'Cao cấp',
    },
  },
  vectorSpace: {
    fullTip: 'Không gian Vector đã đầy.',
    fullSolution: 'Nâng cấp kế hoạch của bạn để có thêm không gian.',
  },
  apps: {
    fullTipLine1: 'Nâng cấp kế hoạch của bạn để',
    fullTipLine2: 'xây dựng thêm ứng dụng.',
    contactUs: 'Liên hệ với chúng tôi',
    fullTip2: 'Đã đạt giới hạn kế hoạch',
    fullTip1des: 'Bạn đã đạt đến giới hạn xây dựng ứng dụng trên kế hoạch này.',
    fullTip1: 'Nâng cấp để tạo thêm ứng dụng',
    fullTip2des: 'Chúng tôi khuyên bạn nên xóa các ứng dụng không hoạt động để giải phóng dung lượng, hoặc liên hệ với chúng tôi.',
  },
  annotatedResponse: {
    fullTipLine1: 'Nâng cấp kế hoạch của bạn để',
    fullTipLine2: 'ghi chú thêm cuộc trò chuyện.',
    quotaTitle: 'Hạn Mức Quota Phản hồi Đã được Ghi chú',
  },
  usagePage: {
    documentsUploadQuota: 'Hạn ngạch tải lên tài liệu',
    annotationQuota: 'Hạn ngạch chú thích',
    vectorSpaceTooltip: 'Các tài liệu với chế độ lập chỉ mục Chất lượng Cao sẽ tiêu tốn tài nguyên Lưu trữ Dữ liệu Kiến thức. Khi Lưu trữ Dữ liệu Kiến thức đạt giới hạn, các tài liệu mới sẽ không được tải lên.',
    teamMembers: 'Các thành viên trong nhóm',
    vectorSpace: 'Lưu trữ dữ liệu kiến thức',
    buildApps: 'Xây dựng ứng dụng',
  },
  teamMembers: 'Các thành viên trong nhóm',
}

export default translation
